import { useEffect, useState, useRef } from "react";
import { AxiosPrivado } from "../../componentes/axios/Axios";
import {
    ClienteListar,
    ProductosListar,
    ProductosListarVenta,
    ProductosTiposListar,
    BancosListar,
    EmpleadosListar,
    InventariosTiposListar,
} from "../../configuracion/apiUrls";
import { useContextUsuario } from "../usuario/UsuarioContext";
import { EmpleadoContext } from "./EmpleadoContext";
export const EmpleadoState = (props) => {
    const { token } = useContextUsuario();
    const [empleado, setEmpleado] = useState(null);
    const [listaEmpleados, setListaEmpleados] = useState([]);
    const [listaCargos, setListaCargos] = useState([]);
    const [listaProductosBajoStock, setListaProductosBajoStock] = useState([]);
    const [listaClientes, setListaClientes] = useState([]);
    const [listaProveedores, setListaProveedores] = useState([]);
    const [listaProductos, setListaProductos] = useState([]);
    const [listaTiposProductos, setListaTiposProductos] = useState([]);
    const [listaPedidos, setListaPedidos] = useState([]);
    const [listaVentas, setListaVentas] = useState([]);
    const [listaCompras, setListaCompras] = useState([]);
    const [listaAperturas, setListaApertura] = useState([]);
    const [listaCierres, setListaCierre] = useState([]);
    const [actualizar, setActualizar] = useState(false);
    const [listaPagosVentas, setListaPagosVentas] = useState([]);
    const [listaPagosCompras, setListaPagosCompras] = useState([]);
    const [listaCreditosVencidosCompras, setListaCreditosVencidosCompras] = useState([]);
    const [listaCreditosVencidosVentas, setListaCreditosVencidosVentas] = useState([]);
    const [listaInventarios, setListaInventarios] = useState([]);
    const [listaInventariosTipos, setListaInventariosTipos] = useState([]);
    const [listaPromociones, setListaPromociones] = useState([]);
    //const [alertasStock, setAlertasStock] = useState([]);
    //const [alertasCreditosVencidos, setAlertasCreditosVencidos] = useState([]);
    const [listaLotesInvetarios, setListaLotesInventarios] = useState([]);
    const [listaIngresosEgresos, setListaIngresosEgresos] = useState([]);
    const [listaBancos, setListaBancos] = useState([]);
    const [listaVentasFiltradas, setListaVentasFiltradas] = useState([]);
    const [listaComprasFiltradas, setListaComprasFiltradas] = useState([]);
/*
    useEffect(() => {
        const generarAlertas = () => {
            const stockAlerts = listaProductosBajoStock.map(prod => ({
                title: "¡Atención!",
                subtitle: "Stock bajo",
                message: `El producto "${prod.nombre}" está bajo el punto de reorden.`,
                type: "bg-warning",
                id: `stock-${prod.id}`,
            }));
            setAlertasStock(stockAlerts);

            const comprasAlerts = listaCreditosVencidosCompras.map(credito => {
                const fecha = new Date(credito.fechaVencimiento).toLocaleDateString('es-HN');
                return {
                    title: "¡Crédito de compra vencido!",
                    subtitle: "Proveedor en mora",
                    message: `El proveedor ${credito.compra?.proveedor?.nombre ?? 'N/A'} tiene una deuda vencida por L. ${credito.saldo}. Venció el ${fecha}.`,
                    type: "bg-danger",
                    category: "compra",
                    id: `compra-${credito.id}`,
                };
            });

            const ventasAlerts = listaCreditosVencidosVentas.map(credito => {
                const fecha = new Date(credito.fechaVencimiento).toLocaleDateString('es-HN');
                return {
                    title: "¡Crédito de venta vencido!",
                    subtitle: "Cliente en mora",
                    message: `El cliente ${credito.venta?.Cliente?.nombreCompleto ?? 'N/A'} tiene una deuda vencida por L. ${credito.saldo}. Venció el ${fecha}.`,
                    type: "creditoVenta",
                    category: "venta",
                    id: `venta-${credito.id}`,
                };
            });
            setAlertasCreditosVencidos([...comprasAlerts, ...ventasAlerts]);
        };

        generarAlertas();

    }, [listaProductosBajoStock, listaCreditosVencidosCompras, listaCreditosVencidosVentas]);

*/
    const Lista = async () => {
        try {
            await ActualizarLista(EmpleadosListar, setListaEmpleados);
            //await ActualizarLista(CargosListar, setListaCargos);
            //await ActualizarLista(ProductoListarBajo, setListaProductosBajoStock);
            await ActualizarLista(ClienteListar, setListaClientes);
            //await ActualizarLista(ProveedoresListar, setListaProveedores);
            await ActualizarLista(ProductosListarVenta, setListaProductos);
            await ActualizarLista(ProductosTiposListar, setListaTiposProductos);
            //await ActualizarLista(PedidosListar, setListaPedidos);
            //await ActualizarLista(VentaListar, setListaVentas);
            //await ActualizarLista(ComprasListar, setListaCompras);
            //await ActualizarLista(AperturaListar, setListaApertura);
            //await ActualizarLista(CierreListar, setListaCierre);
            //await ActualizarLista(CreditoVencidoCompras, setListaCreditosVencidosCompras);
            //await ActualizarLista(CreditoVencidoVentas, setListaCreditosVencidosVentas);
            //await ActualizarLista(VentaListarPagos, setListaPagosVentas);
            //await ActualizarLista(ComprasListarPagos, setListaPagosCompras);
            //await ActualizarLista(InventariosListar, setListaInventarios);
            await ActualizarLista(InventariosTiposListar, setListaInventariosTipos);
            //await ActualizarLista(PromocionesListar, setListaPromociones);
            //await ActualizarLista(LotesInventarioListar, setListaLotesInventarios);
            //await ActualizarLista(IngresosEgresosListar, setListaIngresosEgresos);
            await ActualizarLista(BancosListar, setListaBancos);
            //await ActualizarLista(VentaFiltro, setListaVentasFiltradas);
            //await ActualizarLista(CompraFiltro, setListaComprasFiltradas);
        } catch (error) {
            console.log(error);
        }
    };

    const cargado = useRef(false);

    useEffect(() => {
        if (!cargado.current) {
            Lista();
            cargado.current = true;
        }
    }, []);

    const ActualizarLista = async (url, setDatos) => {
        AxiosPrivado.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        try {
            const respuesta = await AxiosPrivado.get(url);
            setDatos(respuesta.data);
        } catch (error) {
            console.log(error);
            setDatos([]);
        }
    };

    const ActualizarProductos = async () => {
        AxiosPrivado.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        try {
            const respuesta = await AxiosPrivado.get(ProductosListarVenta);
            setListaProductos(respuesta.data);
        } catch (error) {
            console.log(error);
            setListaProductos([]);
        }
    };

    return (
        <EmpleadoContext.Provider
            value={{
                empleado,
                listaEmpleados,
                listaCargos,
                listaProductosBajoStock,
                listaClientes,
                listaProveedores,
                listaProductos,
                listaTiposProductos,
                listaPedidos,
                listaVentas,
                listaCompras,
                listaAperturas,
                listaCierres,
                listaCreditosVencidosCompras,
                listaCreditosVencidosVentas,
                listaPagosVentas,
                listaPagosCompras,
                listaInventarios,
                listaInventariosTipos,
                listaLotesInvetarios,
                listaPromociones,
                listaIngresosEgresos,
                listaBancos,
                listaVentasFiltradas,
                listaComprasFiltradas,
                actualizar,
                //alertasStock,
                //alertasCreditosVencidos,
                setActualizar,
                setEmpleado,
                setListaEmpleados,
                setListaCargos,
                setListaProductosBajoStock,
                setListaClientes,
                setListaProveedores,
                setListaProductos,
                setListaTiposProductos,
                setListaPedidos,
                setListaVentas,
                setListaCompras,
                setListaApertura,
                setListaCierre,
                setListaCreditosVencidosCompras,
                setListaCreditosVencidosVentas,
                setListaPagosVentas,
                setListaPagosCompras,
                setListaInventarios,
                setListaInventariosTipos,
                setListaLotesInventarios,
                setListaPromociones,
                setListaIngresosEgresos,
                setListaBancos,
                setListaVentasFiltradas,
                setListaComprasFiltradas,
                Lista,
                ActualizarLista,
                ActualizarProductos
            }}
        >
            {props.children}
        </EmpleadoContext.Provider>
    );
};
